import * as React from "react";
const SvgDesktop2 = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" data-name="Trazado 819" style={{
    fill: "none"
  }} /><path d="M20 2H4a1.993 1.993 0 0 0-2 2v11a1.993 1.993 0 0 0 2 2h4v5l4-2 4 2v-5h4a1.993 1.993 0 0 0 2-2V4a1.993 1.993 0 0 0-2-2m0 13H4v-2h16zm0-5H4V4h16z" data-name="Trazado 820" style={{
    fill: "rgba(60,60,60,.7)"
  }} /></svg>;
export { SvgDesktop2 as ReactComponent };